import { findMessageId } from './source-form-locators';
import {
	AI_QUESTION1_ID,
	AI_QUESTION1_KEY,
	AI_QUESTION2_ID,
	AI_QUESTION2_KEY,
	NEXT_BUTTON_ID,
	NEXT_BUTTON_KEY,
	STATE_ID,
	STATE_KEY,
} from './constants';

const USE_APP = document.getElementsByClassName('ENABLE_AI_SUGGESTION_APP').length === 1;
const ENDPOINT_URL = '/wp-json/tr/site-endpoints/v2/ai/v1/suggestions';
const HTTP_TIMEOUT = 5;

const $ = jQuery;

/**
 * @returns {*}
 */
function buildNextButtonControllerClass() {
	return window.Marionette.Object.extend({
		adobeEvents: null,
		stateField: null,
		messageField: null,
		aiQuestion1Field: null,
		aiQuestion2Field: null,
		nextButtonField: null,
		suggestionsCalled: false,
		formPrefixId: null,
		formId: null,
		initialize({
			formId, formPrefixId, fields, adobeEvents,
		}) {
			this.adobeEvents = adobeEvents;
			this.formPrefixId = formPrefixId;
			this.messageField = this.getField(findMessageId(fields));
			if ($('.ENABLE_EDITABLE_LAYOUT_OF_AI_FORMS').length === 1) {
				this.stateField = this.getFieldByKey(fields, STATE_KEY);
				this.aiQuestion1Field = this.getFieldByKey(fields, AI_QUESTION1_KEY);
				this.aiQuestion2Field = this.getFieldByKey(fields, AI_QUESTION2_KEY);
				this.nextButtonField = this.getFieldByKey(fields, NEXT_BUTTON_KEY);
			} else {
				this.stateField = this.getField(this.formPrefixId + STATE_ID);
				this.aiQuestion1Field = this.getField(this.formPrefixId + AI_QUESTION1_ID);
				this.aiQuestion2Field = this.getField(this.formPrefixId + AI_QUESTION2_ID);
				this.nextButtonField = this.getField(this.formPrefixId + NEXT_BUTTON_ID);
			}
			this.formId = formId;
			// on submit, we need to inject the AI fields
			const formChannel = nfRadio.channel(`form-${formId}`);
			this.listenTo(formChannel, 'before:submit', this.injectAIFieldsIntoRequest);
			// on the Field's model value change...
			const fieldsChannel = Backbone.Radio.channel('fields');
			this.listenTo(fieldsChannel, 'change:modelValue', this.submitForSuggestions);
			// prepare the next button
			this.setupNextButton();
		},
		getField(fieldId) {
			return nfRadio.channel('fields').request('get:field', fieldId);
		},
		getFieldByKey(fields, key) {
			let found = false;
			for (let i = 0; i < fields.length; i += 1) {
				if ((fields[i].key === key) || (fields[i].admin_label === key)) {
					found = i;
					break;
				}
				if (fields[i].key.startsWith(key)) {
					found = i;
					break;
				}
			}
			if (found === false) {
				throw new Error(`Field with key ${key} not found`);
			}
			return this.getField(fields[found].id);
		},
		injectAIFieldsIntoRequest(formModel) {
			if (this.stateField.get('value') === 'questions') {
				const extra = formModel.get('extra');
				extra.aiQuestions = {};
				extra.aiQuestions[this.aiQuestion1Field.get('label')] = this.aiQuestion1Field.get('value');
				extra.aiQuestions[this.aiQuestion2Field.get('label')] = this.aiQuestion2Field.get('value');
				formModel.set('extra', extra);
			}
		},
		setupNextButton() {
			Backbone.Radio.channel(`field-${this.nextButtonField.get('id')}`).off('click:field');
			const self = this;
			$(document).on('click', `#nf-field-${this.nextButtonField.get('id')}`, (e) => {
				e.preventDefault();
				e.stopPropagation();
				self.stateField.set('value', 'processing');
				self.stateField.trigger('reRender');
				self.adobeEvents.trackNextButtonClicked();
				return false;
			});
		},
		responseCallBack({ data: { response: { choices } } }) {
			let questions = [];
			const content = choices[0].message.content;
			let fieldId = false;

			if (content) {
				questions = this.normaliseQuestions(content);
			}

			if (questions.length) {
				this.aiQuestion1Field.set('label', questions[0]);
				this.aiQuestion2Field.set('label', questions[1]);
				this.aiQuestion1Field.trigger('reRender');
				this.aiQuestion2Field.trigger('reRender');
				this.stateField.set('value', 'questions');
				fieldId = this.aiQuestion1Field.get('id');
			} else {
				this.stateField.set('value', 'no_questions');
				fieldId = this.messageField.get('id');
			}
			this.stateField.trigger('reRender');
			// Inform outer scripts (for example a11y scripts) about update of the form
			jQuery(document).trigger('aiEnhancedFormUpdate', {
				$el: [$(`#nf-form-${this.formId}-cont`).get(0)],
			});
			this.adobeEvents.trackSmartQuestionsAsked(...questions);
			const selector = `#nf-field-${fieldId}`;
			jQuery(selector).focus();
		},
		submitForSuggestions(model) {
			const isMatchingField = (model.id === this.stateField.get('id')) && (model.get('value') === 'processing');
			if (!isMatchingField) {
				return;
			}
			if (this.suggestionsCalled) {
				window.console.log('Skipping the Suggestions: already called once');
				return;
			}
			this.suggestionsCalled = true;
			const self = this;

			let postData = { message: this.messageField.get('value') };

			if (USE_APP) {
				postData = JSON.stringify({ data: { user_message: this.messageField.get('value') } });
			}

			$.ajax(
				USE_APP ? flGlobalSettings.AI_SUGGESTIONS_ENDPOINT_APP : ENDPOINT_URL,
				{
					method: 'POST',
					data: postData,
					timeout: HTTP_TIMEOUT * 1000,
				},
			).done(data => self.responseCallBack(data)).fail((jqXHR, textStatus, errorThrown) => {
				console.log('Captured error while doing Ajax call: ', jqXHR, textStatus, errorThrown);
				const emptyDataSet = {
					data: {
						response: {
							choices: [{
								message: {
									content: '[]',
								},
							}],
						},
					},
				};
				return self.responseCallBack(emptyDataSet);
			});
		},
		normaliseQuestions(content) {
			try {
				const incomingQuestions = JSON.parse(content);

				if (!USE_APP) {
					return incomingQuestions;
				}

				const questions = [];

				if (incomingQuestions.Question1) {
					questions.push(incomingQuestions.Question1);
				}

				if (incomingQuestions.Question2) {
					questions.push(incomingQuestions.Question2);
				}

				return questions;
			} catch (e) {
				return [];
			}
		},
	});
}

export default buildNextButtonControllerClass;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/forms/ai-enhanced-form-fields/buildNextButtonController.js